<template>
  <img
    :src="src"
    :width="width"
    :height="height"
    alt=""
  >
</template>

<script>
export default {
  name: 'ChromeColorIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      src: require('@/assets/images/chrome-icon.svg')
    }
  }
}
</script>

<style scoped></style>
